import {
  differenceInCalendarDays,
  format,
  isToday,
  isYesterday,
  parseISO,
} from "date-fns";

export function formatNotificationDate(isoDate: string): string {
  const date = parseISO(isoDate);
  const now = new Date();
  const daysDiff = differenceInCalendarDays(now, date);

  if (isToday(date)) {
    return format(date, "hh:mm a");
  }

  if (isYesterday(date)) {
    return "Yesterday";
  }

  if (daysDiff <= 6) {
    return format(date, "EEEE");
  }

  return format(date, "d MMMM");
}
